/**
 * 自动生成的代码，请勿修改
 */
import { doRequest } from './utils';
import type { ResponseType } from './utils';
import type {
  GetPriceCalendarRequest,
  ResponseTripProductPriceCalendarResponse,
  GetProductInfoRequest,
  ResponseGetProductInfoResponse,
  GetRequiredInfoRequest,
  ResponseGetRequiredInfoResponse,
  SearchOrderVerifyRequest,
  ResponseSearchOrderVerifyResponse,
  GetOrderListRequest,
  ResponseGetOrderListResponse,
  GetOrderDetailRequest,
  ResponseGetOrderDetailBffResponse,
  SendVerifyCodeRequest,
  ResponseSendVerifyCodeResponse,
  SendEmailVerifyCodeRequest,
  ResponseSendEmailVerifyCodeResponse,
  OrderRepayBffRequest,
  ResponseOrderRepayBffResponse,
  CreateOrderBffRequest,
  ResponseCreateOrderBffResponse,
  CancelOrderBffRequest,
  ResponseCancelOrderBffResponse,
  RefundOrderBffRequest,
  ResponseRefundOrderBffResponse,
  GetOrderVoucherBffRequest,
  ResponseGetOrderVoucherBffResponse,
  ListCountryRegionRequest,
  ResponseListCountryRegionResponse,
  GetRefundReasonBffRequest,
  ResponseGetRefundReasonBffResponse,
  RefundVerifyBffRequest,
  ResponseRefundVerifyBffResponse,
} from '../types';

const baseUrl = '';

class OrderControllerService {
  /**
   * @summary 获取产品价格日历
   * @fullUrl /order/getPriceCalendar
   */
  public orderGetPriceCalendarPost(
    body: GetPriceCalendarRequest,
  ): ResponseType<ResponseTripProductPriceCalendarResponse> {
    const requestUrl = baseUrl + '/order/getPriceCalendar';
    const res = doRequest<ResponseTripProductPriceCalendarResponse>({
      method: 'post',
      url: requestUrl,
      body,
    });
    return res;
  }
  /**
   * @summary 获取产品信息
   * @fullUrl /order/getProductInfo
   */
  public orderGetProductInfoPost(
    body: GetProductInfoRequest,
  ): ResponseType<ResponseGetProductInfoResponse> {
    const requestUrl = baseUrl + '/order/getProductInfo';
    const res = doRequest<ResponseGetProductInfoResponse>({
      method: 'post',
      url: requestUrl,
      body,
    });
    return res;
  }
  /**
   * @summary 获取下单填写信息
   * @fullUrl /order/getRequiredInfo
   */
  public orderGetRequiredInfoPost(
    body: GetRequiredInfoRequest,
  ): ResponseType<ResponseGetRequiredInfoResponse> {
    const requestUrl = baseUrl + '/order/getRequiredInfo';
    const res = doRequest<ResponseGetRequiredInfoResponse>({
      method: 'post',
      url: requestUrl,
      body,
    });
    return res;
  }
  /**
   * @summary 查询订单验证
   * @fullUrl /order/searchOrderVerify
   */
  public orderSearchOrderVerifyPost(
    body: SearchOrderVerifyRequest,
  ): ResponseType<ResponseSearchOrderVerifyResponse> {
    const requestUrl = baseUrl + '/order/searchOrderVerify';
    const res = doRequest<ResponseSearchOrderVerifyResponse>({
      method: 'post',
      url: requestUrl,
      body,
    });
    return res;
  }
  /**
   * @summary 订单列表
   * @fullUrl /order/getOrderList
   */
  public orderGetOrderListPost(
    body: GetOrderListRequest,
  ): ResponseType<ResponseGetOrderListResponse> {
    const requestUrl = baseUrl + '/order/getOrderList';
    const res = doRequest<ResponseGetOrderListResponse>({
      method: 'post',
      url: requestUrl,
      body,
    });
    return res;
  }
  /**
   * @summary 订单详情
   * @fullUrl /order/getOrderDetail
   */
  public orderGetOrderDetailPost(
    body: GetOrderDetailRequest,
  ): ResponseType<ResponseGetOrderDetailBffResponse> {
    const requestUrl = baseUrl + '/order/getOrderDetail';
    const res = doRequest<ResponseGetOrderDetailBffResponse>({
      method: 'post',
      url: requestUrl,
      body,
    });
    return res;
  }
  /**
   * @summary 发送手机验证码
   * @fullUrl /order/sendVerifyCode
   */
  public orderSendVerifyCodePost(
    body: SendVerifyCodeRequest,
  ): ResponseType<ResponseSendVerifyCodeResponse> {
    const requestUrl = baseUrl + '/order/sendVerifyCode';
    const res = doRequest<ResponseSendVerifyCodeResponse>({
      method: 'post',
      url: requestUrl,
      body,
    });
    return res;
  }
  /**
   * @summary 发送email验证码
   * @fullUrl /order/sendEmailVerifyCode
   */
  public orderSendEmailVerifyCodePost(
    body: SendEmailVerifyCodeRequest,
  ): ResponseType<ResponseSendEmailVerifyCodeResponse> {
    const requestUrl = baseUrl + '/order/sendEmailVerifyCode';
    const res = doRequest<ResponseSendEmailVerifyCodeResponse>({
      method: 'post',
      url: requestUrl,
      body,
    });
    return res;
  }
  /**
   * @summary 订单继续支付
   * @fullUrl /order/repay
   */
  public orderRepayPost(
    body: OrderRepayBffRequest,
  ): ResponseType<ResponseOrderRepayBffResponse> {
    const requestUrl = baseUrl + '/order/repay';
    const res = doRequest<ResponseOrderRepayBffResponse>({
      method: 'post',
      url: requestUrl,
      body,
    });
    return res;
  }
  /**
   * @summary 创建订单
   * @fullUrl /order/create
   */
  public orderCreatePost(
    body: CreateOrderBffRequest,
  ): ResponseType<ResponseCreateOrderBffResponse> {
    const requestUrl = baseUrl + '/order/create';
    const res = doRequest<ResponseCreateOrderBffResponse>({
      method: 'post',
      url: requestUrl,
      body,
    });
    return res;
  }
  /**
   * @summary 取消订单
   * @fullUrl /order/cancel
   */
  public orderCancelPost(
    body: CancelOrderBffRequest,
  ): ResponseType<ResponseCancelOrderBffResponse> {
    const requestUrl = baseUrl + '/order/cancel';
    const res = doRequest<ResponseCancelOrderBffResponse>({
      method: 'post',
      url: requestUrl,
      body,
    });
    return res;
  }
  /**
   * @summary 订单退订
   * @fullUrl /order/refund
   */
  public orderRefundPost(
    body: RefundOrderBffRequest,
  ): ResponseType<ResponseRefundOrderBffResponse> {
    const requestUrl = baseUrl + '/order/refund';
    const res = doRequest<ResponseRefundOrderBffResponse>({
      method: 'post',
      url: requestUrl,
      body,
    });
    return res;
  }
  /**
   * @summary 订单凭证信息
   * @fullUrl /order/getOrderVoucher
   */
  public orderGetOrderVoucherPost(
    body: GetOrderVoucherBffRequest,
  ): ResponseType<ResponseGetOrderVoucherBffResponse> {
    const requestUrl = baseUrl + '/order/getOrderVoucher';
    const res = doRequest<ResponseGetOrderVoucherBffResponse>({
      method: 'post',
      url: requestUrl,
      body,
    });
    return res;
  }
  /**
   * @summary 国家地区列表
   * @fullUrl /order/listCountryRegion
   */
  public orderListCountryRegionPost(
    body: ListCountryRegionRequest,
  ): ResponseType<ResponseListCountryRegionResponse> {
    const requestUrl = baseUrl + '/order/listCountryRegion';
    const res = doRequest<ResponseListCountryRegionResponse>({
      method: 'post',
      url: requestUrl,
      body,
    });
    return res;
  }
  /**
   * @summary 订单退订原因列表
   * @fullUrl /order/getRefundReason
   */
  public orderGetRefundReasonPost(
    body: GetRefundReasonBffRequest,
  ): ResponseType<ResponseGetRefundReasonBffResponse> {
    const requestUrl = baseUrl + '/order/getRefundReason';
    const res = doRequest<ResponseGetRefundReasonBffResponse>({
      method: 'post',
      url: requestUrl,
      body,
    });
    return res;
  }
  /**
   * @summary 订单退订检查
   * @fullUrl /order/refundVerify
   */
  public orderRefundVerifyPost(
    body: RefundVerifyBffRequest,
  ): ResponseType<ResponseRefundVerifyBffResponse> {
    const requestUrl = baseUrl + '/order/refundVerify';
    const res = doRequest<ResponseRefundVerifyBffResponse>({
      method: 'post',
      url: requestUrl,
      body,
    });
    return res;
  }
}

export const orderController = new OrderControllerService();
